import React from 'react'
import './Title.css';
import Logo from '../Logo/Logo';

function Title({ children, logoType }) {
  return (
    <div className="formDiv">
      <Logo> {logoType} </Logo>
      <h3 className="formTitle">{children}</h3>
    </div>
  );
}

export default Title;